import { createContext, useContext } from 'react';

export const InvoiceContext = createContext();

export const useInvoiceContext = () => useContext(InvoiceContext);

export const InvoiceEditContext = createContext();

export const useInvoiceEditContext = () => useContext(InvoiceEditContext);
